import { render, staticRenderFns } from "./Eredmenyek.vue?vue&type=template&id=68fbad72&"
import script from "./Eredmenyek.vue?vue&type=script&lang=js&"
export * from "./Eredmenyek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports